// Early access (temporary): told when the server refuses this account because the tabletop is not unlocked for it —
// a 403 `locked` from any call through `authFetch`, or the socket's handshake refused `locked`. The table page listens
// and shows the early-access screen. No imports, so the session and the page can both use it.
const listeners = new Set<() => void>();

export function onLocked(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function tellLocked(): void {
  for (const l of [...listeners]) l();
}
